__turbopack_context__.v({
  "blockDivider": "WhenTabContent-module__IK056W__blockDivider",
  "menuImageContainer": "WhenTabContent-module__IK056W__menuImageContainer",
  "menuImageFirstHighlightedWrapper": "WhenTabContent-module__IK056W__menuImageFirstHighlightedWrapper",
  "menuImageOtherHighlightedWrapper": "WhenTabContent-module__IK056W__menuImageOtherHighlightedWrapper",
  "tabContent": "WhenTabContent-module__IK056W__tabContent",
  "thematicLinkContainer": "WhenTabContent-module__IK056W__thematicLinkContainer",
});
